import React from 'react';
import NumberFormat from 'react-number-format'
import pdfLogo from 'images/pdf-logo.png'
import { NumberFormatOptions } from '../../../helpers/const'

const Content = ({ mediaPlan }) => (
  <React.Fragment>
    <main className="media-plan-table-container col-12 mx-auto pdf-p4 relative sm-p3">
      <div className="sm-overflow-x-auto">
        <div className="pdf-logo pdf-logo--media" style={{ backgroundImage: `url(${pdfLogo})` }} />

        <p className="h1 hidden mb3 pdf-show">
          {mediaPlan.country}
          &nbsp;- $<NumberFormat value={mediaPlan.budget} {...NumberFormatOptions} />
          &nbsp;- {new Date(mediaPlan.created_at).toLocaleDateString('en-EN', { year: 'numeric', month: 'long', day: '2-digit' })}
        </p>

        <p className="center fs-18 mb3 sm-h4">This plan shows you the minimum returns you should get on your media investment. Proper planning, ongoing optimization and great content can improve the performance of every dollar invested.</p>

        <table className="media-plan-table border border-gallery box-shadow col-12 mx-auto pdf-fs-12">
          <tbody>
            <tr>
              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Channels</th>

              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Ad Type</th>

              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Est. Imp</th>

              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Est. CTR</th>

              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Est. Clicks</th>

              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Est. CPC</th>

              <th className="border-bottom border-right border-gallery medium p2 pdf-p1">Allocation</th>

              <th className="border-bottom border-gallery medium p2 pdf-p1 right-align text-flirt">Monthly budget</th>
            </tr>

            <tr className="pdf-hide">
              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td>&nbsp;</td>
            </tr>

            <tr className="h5 pdf-fs-12">
              <td className="border-right border-gallery medium p2 pdf-p1">Google Display Network</td>

              <td className="border-right border-gallery p2 pdf-p1">text/banner</td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_network.impressions} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_network.ctr} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_network.clicks} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_network.cpc} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_network.allocation} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="p2 pdf-p1 right-align">
                <p className="bg-wisp-pink center medium rounded-16 text-flirt" style={{ lineHeight: '32px' }}>
                  <NumberFormat value={mediaPlan.google_network.monthly_cost} {...NumberFormatOptions} prefix="$" />
                </p>
              </td>
            </tr>

            <tr className="h5 pdf-fs-12">
              <td className="border-right border-gallery medium p2 pdf-p1">Google Adwords</td>

              <td className="border-right border-gallery p2 pdf-p1">Text</td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_search.impressions} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_search.ctr} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_search.clicks} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_search.cpc} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.google_search.allocation} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="p2 pdf-p1 right-align">
                <p className="bg-wisp-pink center medium rounded-16 text-flirt" style={{ lineHeight: '32px' }}>
                  <NumberFormat value={mediaPlan.google_search.monthly_cost} {...NumberFormatOptions} prefix="$" />
                </p>
              </td>
            </tr>

            <tr className="h5 pdf-fs-12">
              <td className="border-right border-gallery medium p2 pdf-p1">Facebook</td>

              <td className="border-right border-gallery p2 pdf-p1">image/video</td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.facebook.impressions} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.facebook.ctr} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.facebook.clicks} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.facebook.cpc} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.facebook.allocation} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="p2 pdf-p1 right-align">
                <p className="bg-wisp-pink center medium rounded-16 text-flirt" style={{ lineHeight: '32px' }}>
                  <NumberFormat value={mediaPlan.facebook.monthly_cost} {...NumberFormatOptions} prefix="$" />
                </p>
              </td>
            </tr>

            <tr className="h5 pdf-fs-12">
              <td className="border-right border-gallery medium p2 pdf-p1">Instagram</td>

              <td className="border-right border-gallery p2 pdf-p1">video</td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.instagram.impressions} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.instagram.ctr} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.instagram.clicks} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.instagram.cpc} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.instagram.allocation} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="p2 pdf-p1 right-align">
                <p className="bg-wisp-pink center medium rounded-16 text-flirt" style={{ lineHeight: '32px' }}>
                  <NumberFormat value={mediaPlan.google_network.monthly_cost} {...NumberFormatOptions} prefix="$" />
                </p>
              </td>
            </tr>

            <tr className="h5 pdf-fs-12">
              <td className="border-right border-gallery medium p2 pdf-p1">Youtube</td>

              <td className="border-right border-gallery p2 pdf-p1">Text</td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.youtube.impressions} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.youtube.ctr} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.youtube.clicks} displayType="text" thousandSeparator=" " />
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.youtube.cpc} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="border-right border-gallery center p2 pdf-p1">
                <NumberFormat value={mediaPlan.youtube.allocation} displayType="text" thousandSeparator=" " />%
              </td>

              <td className="p2 pdf-p1 right-align">
                <p className="bg-wisp-pink center medium rounded-16 text-flirt" style={{ lineHeight: '32px' }}>
                  <NumberFormat value={mediaPlan.youtube.monthly_cost} {...NumberFormatOptions} prefix="$" />
                </p>
              </td>
            </tr>

            <tr className="pdf-hide">
              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td className="border-right border-gallery">&nbsp;</td>

              <td>&nbsp;</td>
            </tr>

            <tr className="fs-18 medium text-flirt">
              <td className="border-top border-gallery p2 pdf-p1">Total</td>

              <td className="border-top border-gallery p2 pdf-p1" />

              <td className="border-top border-gallery center p2 pdf-p1">
                <NumberFormat
                  displayType="text"
                  thousandSeparator=" "
                  value={
                    mediaPlan.facebook.impressions +
                    mediaPlan.instagram.impressions +
                    mediaPlan.google_network.impressions +
                    mediaPlan.google_search.impressions +
                    mediaPlan.youtube.impressions
                  }
                />
              </td>

              <td className="border-top border-gallery p2 pdf-p1" />

              <td className="border-top border-gallery center p2 pdf-p1">
                <NumberFormat
                  displayType="text"
                  thousandSeparator=" "
                  value={
                    mediaPlan.facebook.clicks +
                    mediaPlan.instagram.clicks +
                    mediaPlan.google_network.clicks +
                    mediaPlan.google_search.clicks +
                    mediaPlan.youtube.clicks
                  }
                />
              </td>

              <td className="border-top border-gallery p2 pdf-p1" />

              <td className="border-top border-gallery p2 pdf-p1" />

              <td className="border-top border-gallery center p2 pdf-p1">
                <NumberFormat
                  {...NumberFormatOptions}
                  prefix="$"
                  value={
                    mediaPlan.facebook.monthly_cost +
                    mediaPlan.instagram.monthly_cost +
                    mediaPlan.google_network.monthly_cost +
                    mediaPlan.google_search.monthly_cost +
                    mediaPlan.youtube.monthly_cost
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>

        <p className="hidden pdf-show">Generated on {new Date(mediaPlan.created_at).toLocaleDateString('en-EN', { year: 'numeric', month: 'long', day: '2-digit' })}</p>
      </div>
    </main>
  </React.Fragment>
);

export default Content
